'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_CreateGeneralPracticeRequest$UserData$$anon$20(evaluator$17) {
  this.Lapp_api_CreateGeneralPracticeRequest$UserData$$anon$20__f_evaluator$7 = null;
  this.Lapp_api_CreateGeneralPracticeRequest$UserData$$anon$20__f_evaluator$7 = evaluator$17;
}
export { $c_Lapp_api_CreateGeneralPracticeRequest$UserData$$anon$20 as $c_Lapp_api_CreateGeneralPracticeRequest$UserData$$anon$20 };
$c_Lapp_api_CreateGeneralPracticeRequest$UserData$$anon$20.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_CreateGeneralPracticeRequest$UserData$$anon$20.prototype.constructor = $c_Lapp_api_CreateGeneralPracticeRequest$UserData$$anon$20;
/** @constructor */
function $h_Lapp_api_CreateGeneralPracticeRequest$UserData$$anon$20() {
}
export { $h_Lapp_api_CreateGeneralPracticeRequest$UserData$$anon$20 as $h_Lapp_api_CreateGeneralPracticeRequest$UserData$$anon$20 };
$h_Lapp_api_CreateGeneralPracticeRequest$UserData$$anon$20.prototype = $c_Lapp_api_CreateGeneralPracticeRequest$UserData$$anon$20.prototype;
$c_Lapp_api_CreateGeneralPracticeRequest$UserData$$anon$20.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_api_CreateGeneralPracticeRequest$UserData$$anon$20.prototype.apply__s_Option = (function() {
  var v = this.Lapp_api_CreateGeneralPracticeRequest$UserData$$anon$20__f_evaluator$7.apply__O();
  return (((typeof v) === "string") ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(v) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lapp_api_CreateGeneralPracticeRequest$UserData$$anon$20.prototype.apply__O = (function() {
  return this.apply__s_Option();
});
var $d_Lapp_api_CreateGeneralPracticeRequest$UserData$$anon$20 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_CreateGeneralPracticeRequest$UserData$$anon$20, "app.api.CreateGeneralPracticeRequest$UserData$$anon$20", ({
  Lapp_api_CreateGeneralPracticeRequest$UserData$$anon$20: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_api_CreateGeneralPracticeRequest$UserData$$anon$20 as $d_Lapp_api_CreateGeneralPracticeRequest$UserData$$anon$20 };
//# sourceMappingURL=app.api.-Create-General-Practice-Request$-User-Data$$anon$20.js.map
